module.exports = __webpack_public_path__ + "img/undraw_Finance_re_gnv2.596b611e.svg";